import { render, staticRenderFns } from "./WidgetConfig.vue?vue&type=template&id=1130af9e&"
import script from "./WidgetConfig.vue?vue&type=script&lang=js&"
export * from "./WidgetConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports